document.addEventListener("DOMContentLoaded", function() {
    function injectUpsellContent(container) {
        console.log("Injecting upsell content...", container);

        const contentElement = container.querySelector('[data-essential-upsell-element="content"]');
        if (contentElement) {
            // Product
            const newContent = document.createElement('div');
            newContent.innerHTML = '<div class="injected-upsell-badges"><div class="injected-upsell-badge">10 Drinks</div><div class="injected-upsell-badge">-43%</div></div>';
            newContent.classList.add('injected-upsell-content');
            contentElement.prepend(newContent);
            const h3Element = contentElement.querySelector('h3');
            if (h3Element) {
                newContent.prepend(h3Element);
            }

            // Header
            // create a new a element inside [data-essential-upsell-element="header"]
            const headerElement = container.querySelector('[data-essential-upsell-element="header"]');
            if (headerElement) {
                if(!headerElement.querySelector('.injected-upsell-header-text')) {
                    const newHeader = document.createElement('a');
                    newHeader.innerHTML = 'weitere Produktinformationen';
                    newHeader.classList.add('injected-upsell-header-link');
                    const oldLink = newContent.querySelector('h3 a');
                    const href = oldLink ? newContent.querySelector('h3 a').getAttribute('href') : '#';
                    newHeader.setAttribute('href', href);
                    newHeader.setAttribute('target', '_blank');
                    headerElement.appendChild(newHeader);

                    oldLink.removeAttribute('href');

                    // on click oldLink, toggle checkbox inside [data-essential-upsell-element="content-container"]
                    oldLink.addEventListener('click', function(event) {
                        event.preventDefault();
                        const contentContainer = container.querySelector('[data-essential-upsell-element="content-container"]');
                        if (contentContainer) {
                            const checkbox = contentContainer.querySelector('input[type="checkbox"]');
                            if (checkbox) {
                                checkbox.checked = !checkbox.checked;
                                const changeEvent = new Event('change');
                                checkbox.dispatchEvent(changeEvent);
                            }
                        }
                    });
                }
            } else {
                console.warn('Header element not found for upsell injection.');
            }
        } else {
            console.warn('Content element not found for upsell injection.');
        }
    }

    // Listen for changes in .product-add-to-cart-container.
    const targetNode = document.querySelector('.product-add-to-cart-container');
    const config = { childList: true, subtree: true };
    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const upsellContent = node.querySelector('[data-essential-upsell-element="discounted-price"]');
                        if (upsellContent) {
                            injectUpsellContent(targetNode.querySelector('.essential-upsell-addon-container'));
                        }
                    }
                });
            }
        }
    };
    const observer = new MutationObserver(callback);
    if (targetNode) {
        observer.observe(targetNode, config);
    }
});
